module.exports = __webpack_public_path__ + "img/home03.425c8d8d.jpg";